<template>
  <div style="margin-top: -80px;">
    <!-- Hero Section -->
    <div class="hero-section" style="padding-top: 80px;">
      <div class="hero-content mx-auto">

        <div class="absolute inset-x-0 top-0 h-96 rotate-180 text-gray-500/20 opacity-60 mask-gradient"><svg
            class="absolute inset-0 h-full w-full" xmlns="http://www.w3.org/2000/svg" style="color: #165208">
            <defs>
              <pattern id="grid-pattern" width="32" height="32" patternUnits="userSpaceOnUse" x="50%" y="100%"
                patternTransform="translate(0 -1)">
                <path d="M0 32V.5H32" fill="none" stroke="currentColor"></path>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-pattern)"></rect>
          </svg></div>


        <!-- <div style="min-height: 300px;"></div> -->


        <div class="pb-16 pt-4">
          <div class="text-center" style="max-width: 1000px; margin-left: auto; margin-right: auto;">

            <div v-if="false" class="d-flex justify-space-around align-center" style="max-width: 100vw;">
              <v-img src="../../assets/images/documento.webp"
                style="width: 130px; height: 140px; z-index: 2; max-width: 130px; max-height: 140px;"
                id="documento-grande" contain></v-img>



              <div class="d-flex justify-center align-center position-relative" style="flex: 1; margin-left: -20px;">
                <transition-group name="documento-animation" tag="div" class="d-flex justify-center align-center"
                  style="height: 300px; flex: 1">
                  <v-img v-for="i in 10" :key="i + '-documento'" src="../../assets/images/documento.webp"
                    style="width: 40px; height: 40px; margin-left: -40px; z-index: 1;" :style="{
                      animationDelay: `${i * 0.2}s`,
                      animationDuration: '2s',
                      animationIterationCount: 'infinite',
                    }" class="documento-animado" contain></v-img>

                </transition-group>
              </div>

              <v-card color="#F7FBDF" class="pa-2"
                style="border-radius: 6px; z-index: 2; position: relative;box-shadow: rgb(216 219 197) 1px 2px 0px 1px !important"
                flat>
                <v-img src="../../assets/logo.png" id="sele-ai"
                  style="width: 86px; height: 86px; max-width: 86px; max-height: 86px; position: relative; z-index: 2;"
                  contain></v-img>
              </v-card>

              <div class="d-flex justify-center align-center position-relative" style="flex: 1; margin-left: -20px;">
                <transition-group name="documento-animation" tag="div" class="d-flex justify-center align-center"
                  style="height: 300px; flex: 1;">
                  <span v-for="i in 10" :key="i + '-spark'"
                    style="width: 40px; height: 40px; margin-left: -40px; z-index: 1;" :style="{
                      animationDelay: `${i * 0.2}s`,
                      animationDuration: '2s',
                      animationIterationCount: 'infinite',
                    }" class="spark d-flex justify-center align-center">✨
                  </span>
                </transition-group>
              </div>

              <v-img src="../../assets/images/quiz.png"
                style="width: 120px; height: 120px; z-index: 2; max-width: 120px; max-height: 120px;" id="quiz"
                contain></v-img>


            </div>

            <h1 class="mb-6 mt-10"
              style="line-height: 1.4; letter-spacing: -0.03em; font-weight: 700 !important; text-wrap: balance;"
              :style="'font-size: ' + ($vuetify.breakpoint.smAndDown ? '3.2rem' : '3.9rem') + '!important'">
              Estudia de forma<br v-if="$vuetify.breakpoint.smAndDown"> <span id="typing-effect">eficiente</span> <br>
              con <span class="tutor-ai-text">Sele AI</span>
            </h1>

            <span class="subtitle-1 mb-6"
              style="font-size: 1.2rem; color: #828282; display: block; width: 100%; max-width: 100%; padding: 0 15px;">
              Aprovecha el poder de la inteligencia artificial para maximizar tu potencial académico. Transforma tus
              apuntes
              en herramientas de estudio personalizadas y domina cualquier materia con SeleAI a tu lado.
            </span>

            <div class="d-flex justify-center align-center flex-column mt-10">
              <!-- CTA Button -->
              <router-link :to="{ path: '/app/apuntes-preguntas-flashcards/2027', query: $route.query }" class="text-decoration-none">
                <v-btn color="primary" x-large height="56"
                  class="get-started-btn white--text px-8 mb-6 font-weight-medium d-flex align-center justify-center mx-auto"
                  depressed rounded>
                  <span style="font-weight: 600; color: white" class="mr-1">
                    Comenzar Ahora
                  </span>
                  <span style="color: rgb(211 255 213); font-weight: 600;">- Es gratis</span>
                  <lucide-arrow-right class="ml-2" style="width: 20px; height: 20px;"></lucide-arrow-right>
                </v-btn>
              </router-link>

              <div class="text-caption mb-8 d-flex justify-center align-center"
                style="font-weight: 500; font-size: 0.9rem; color: rgb(174 192 175);">

                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="18" height="18" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512"
                  xml:space="preserve" class="">
                  <g>
                    <path
                      d="M512 163v-27c0-30.928-25.072-56-56-56H56c-30.928 0-56 25.072-56 56v27a5 5 0 0 0 5 5h502a5 5 0 0 0 5-5zM0 205v171c0 30.928 25.072 56 56 56h400c30.928 0 56-25.072 56-56V205a5 5 0 0 0-5-5H5a5 5 0 0 0-5 5zm128 131c0 8.836-7.164 16-16 16H96c-8.836 0-16-7.164-16-16v-16c0-8.836 7.164-16 16-16h16c8.836 0 16 7.164 16 16z"
                      fill="rgb(130 140 130)" opacity="1" data-original="#000000" class=""></path>
                  </g>
                </svg>
                <span class="ml-2">


                  <span style="color: rgb(130 140 130); font-weight: 600; font-size: 0.8rem;">
                    No se requiere tarjeta
                  </span>
                </span>
              </div>

            </div>



            <div class="mx-auto px-4" style="width: 100%; max-width: 700px;">
              <v-carousel hide-delimiters class="rounded-xl carousel-container-home" cycle autoplay
                :width="$vuetify.breakpoint.smAndDown ? 200 : 700" :height="$vuetify.breakpoint.smAndDown ? 280 : 500">
                <v-carousel-item v-for="(item, i) in imagesCarousel" :key="i" :src="item.src" contain
                  :aspect-ratio="16 / 9"></v-carousel-item>
              </v-carousel>
            </div>

            <!-- <div class="d-flex justify-center align-center">
              <v-rating :value="5" :length="5" color="primary" background-color="primary"
                class="rating-stars"></v-rating>
            </div> -->

            <!-- Trusted By -->
            <div class="d-flex justify-center align-center">
              <div class="trusted-by-section mt-8 d-flex"
                :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-center' : 'align-center mx-auto flex-wrap'">
                <span class="mr-2 text-center" :class="$vuetify.breakpoint.smAndDown ? 'mb-2' : 'pl-5'">Usado por más de
                  +4k estudiantes</span>
                <div class="d-flex justify-center align-center user-avatars ml-4 mr-1">
                  <v-avatar :size="32" class="mx-1 user-avatar-google">
                    <v-img src="../../assets/users/unnamed.jpg"></v-img>
                  </v-avatar>
                  <v-avatar :size="32" class="mx-1 user-avatar-google">
                    <v-img src="../../assets/users/marr.jpg"></v-img>
                  </v-avatar>
                  <v-avatar :size="32" class="mx-1 user-avatar-google" color="#679F38">
                    <span class="white--text font-weight-medium">A</span>
                  </v-avatar>
                  <v-avatar :size="32" class="mx-1 user-avatar-google" color="#03897B">
                    <span class="white--text font-weight-medium">R</span>
                  </v-avatar>
                </div>
                <span :class="$vuetify.breakpoint.smAndDown ? 'mt-2 text-center' : ''">de las mejores instituciones
                  educativas</span>
              </div>
            </div>


            <div class="d-flex justify-center align-center flex-wrap mt-3" style="opacity: 0.8;">
              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/uab.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>

              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/uc3m.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>

              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/upc.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>

              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/upm.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>

              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/upv.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>

              <div class="d-flex align-center ma-2">
                <v-img src="../../assets/uni-logos/upf.webp" min-width="100" min-height="40" height="45" contain
                  style="width: 100px; height: 40px;" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!-- Problem Section -->
    <div class="problem-section pt-8">


      <div class="pt-8" style="width: 100%;max-width: 900px;margin: 0 auto;">
        <h2 class="text-center font-weight-bold mb-8" style="font-size: 2rem; text-wrap: balance">
          El 70% de los estudiantes pierden tiempo estudiando ineficientemente
        </h2>
        <p class="text-center subtitle-1 mb-12" style="font-size: 1.1rem; color: #616161;">
          ¡Deja de perder tiempo! SeleAI resuelve tus problemas de estudio al instante.
        </p>

        <v-row class="mt-12">
          <v-col cols="12" md="4">
            <v-card class="pa-6" color="transparent" elevation="0">
              <div class="d-flex align-center mb-4">
                <v-avatar color="rgb(153 204 117)" :size="48" class="mr-4 problem-avatar">
                  <lucide-book-open style="stroke-width: 1.7px; stroke: rgb(82 131 48)"></lucide-book-open>
                </v-avatar>
                <h3 class="font-weight-bold" style="font-size: 1rem; text-wrap: balance">Demasiados apuntes</h3>
              </div>
              <p class="problem-text" style="font-size: 0.95rem; color: #616161; line-height: 1.6;">
                Organiza tus montañas de apuntes y encuentra lo importante en segundos.
              </p>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="pa-6" color="transparent" elevation="0">
              <div class="d-flex align-center mb-4">
                <v-avatar color="rgb(109 194 107)" :size="48" class="mr-4 problem-avatar">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="#41703f" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-brain-icon lucide-brain white--text">
                    <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
                    <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
                    <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
                    <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
                    <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
                    <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
                    <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
                    <path d="M6 18a4 4 0 0 1-1.967-.516" />
                    <path d="M19.967 17.484A4 4 0 0 1 18 18" />
                  </svg>
                </v-avatar>
                <h3 class="font-weight-bold" style="font-size: 1rem; text-wrap: balance">Olvido rápido</h3>
              </div>
              <p class="problem-text" style="font-size: 0.95rem; color: #616161; line-height: 1.6;">
                Aumenta tu retención hasta un 70% y domina cualquier materia sin esfuerzo.
              </p>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="pa-6" color="transparent" elevation="0">
              <div class="d-flex align-center mb-4">
                <v-avatar color="rgb(255 244 153)" :size="48" class="mr-4 problem-avatar">
                  <lucide-frown color="#b79039" style="stroke-width: 1.7px;"></lucide-frown>
                </v-avatar>
                <h3 class="font-weight-bold" style="font-size: 1rem; text-wrap: balance">Estrés innecesario</h3>
              </div>
              <p class="problem-text" style="font-size: 0.95rem; color: #616161; line-height: 1.6;">
                Elimina la ansiedad y mejora tu rendimiento académico de inmediato.
              </p>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- Solution Section -->
    <section id="solution" class="solution-section">
      <solutions-section style="width: 100%;max-width: 900px;margin: 0 auto;"></solutions-section>
    </section>

    <!-- Examples Section -->
    <section id="examples" class="examples-section py-16">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="d-flex flex-column align-center text-center">
            <div class="badge-wrapper mb-4">
              <div class="badge examples-badge">
                <span>✨ Comunidad</span>
              </div>
            </div>
            <h2 class="font-weight-bold mb-3" style="font-size: 1.5rem; text-wrap: balance">
              Explora contenido creado por la comunidad
            </h2>
            <p class="examples-subtitle"
              style="font-size: 1.1rem; color: #616161; max-width: 700px; margin-left: auto; margin-right: auto;">
              Accede a una biblioteca de apuntes, explicaciones, cuestionarios y flashcards creados por la comunidad. Refuerza conceptos y
              descubre.
            </p>
          </v-col>
        </v-row>
      </v-container>

      <last-example-carousel :popularContent="popularContent"></last-example-carousel>
    </section>

    <section v-if="false" class="numbers-section">

      <div class="py-4 pb-14">

        <!-- Testimonial Stats -->
        <v-row justify="center" class="mt-16">
          <v-col cols="12" md="8" class="text-center">
            <h2 class="section-heading font-weight-bold mb-12" style="font-size: 3rem; text-wrap: balance">
              La plataforma de estudio preferida por los estudiantes
            </h2>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col v-for="(stat, i) in stats" :key="i" cols="6" sm="4" md="3" class="text-center mb-6">
            <div class="stat-value font-weight-bold mb-2" style="font-size: 2.5rem;">
              {{ stat.value }}
            </div>
            <div style="font-size: 1.1rem; color: #616161;">
              {{ stat.label }}
            </div>
          </v-col>
        </v-row>

      </div>
    </section>


    <!-- Pricing Section -->
    <section id="pricing" style="background-color: #f4ffee !important;">

      <v-row justify="center">
        <v-col cols="12" md="8" class="text-center">
          <div class="badge-wrapper mb-4 mt-10">
            <div class="badge pricing-badge">
              <span>💰 Planes</span>
            </div>
          </div>
          <h2 class="font-weight-bold mb-6" style="font-size: 2rem; text-wrap: balance">
            Elige el plan perfecto para tus necesidades
          </h2>
          <p class="pricing-subtitle"
            style="font-size: 1.1rem; color: #616161; max-width: 700px; margin-left: auto; margin-right: auto;">
            Planes flexibles diseñados para ayudarte a sacar el máximo partido a tus estudios, sin importar tu
            presupuesto.
          </p>
        </v-col>
      </v-row>


      <home-pricing-section class="pb-16 pricing-section"></home-pricing-section>


      <v-row v-if="false" justify="center" class="mt-10">
        <v-col cols="12" md="10" class="text-center">
          <v-card class="affiliate-banner pa-6 rounded-xl" outlined>
            <div class="d-flex flex-wrap align-center justify-space-between">
              <div class="d-flex align-center mb-3 mb-md-0">
                <span class="font-weight-bold mr-2">Únete a nuestro programa de afiliados</span>
                <v-chip color="amber lighten-2" x-small class="mr-4">Nuevo</v-chip>
              </div>
              <div class="flex-grow-1 text-center grey--text text--darken-1 mb-3 mb-md-0 px-4">
                ¡Invita usuarios y gana un 50% recurrente en todas las referencias de pago de por vida!
              </div>
              <v-btn text color="primary" class="px-4">
                Saber más
                <lucide-arrow-right :size="16" class="ml-1"></lucide-arrow-right>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="false" justify="center" class="mt-16">
        <v-col cols="12" md="8" class="text-center">
          <div class="money-back-guarantee d-inline-flex align-center py-2 pl-4 pr-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide mr-2 lucide-shield-check-icon lucide-shield-check">
              <path
                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            <span>Garantía de devolución de 30 días sin preguntas</span>
          </div>
        </v-col>
      </v-row>
    </section>


    <!-- Testimonials Section -->
    <section id="testimonials" class="testimonials-section">
      <testimonials-section></testimonials-section>
    </section>


    <!-- FAQs Section -->
    <section id="faqs" class="faqs-section py-16" style="background-color: white !important;">
      <FAQs></FAQs>
    </section>


    <!-- Final CTA Section -->
    <section id="cta" class="cta-section">

      <div style="background-color: #e6f7e8; padding-top: 160px; padding-bottom: 200px;"
        class="px-8 text-center rounded-0" flat>
        <h2 class="font-weight-bold mb-6" style="font-size: 2rem; font-weight: 700; text-wrap: balance">
          Comienza a estudiar de manera más inteligente hoy
        </h2>
        <p class="cta-subtitle mb-8"
          style="font-size: 1.1rem; color: #616161; max-width: 600px; margin-left: auto; margin-right: auto;">
          Únete a más de 1.000 estudiantes que ya están mejorando sus resultados académicos con SeleAI
        </p>
        <router-link :to="{ path: '/app/apuntes-preguntas-flashcards/2027', query: $route.query }" class="text-decoration-none">
          <v-btn x-large depressed height="56" class="primary-btn mb-4" min-width="200">
            <span style="font-size: 1.125rem; color: white">Comenzar Gratis</span>
            <lucide-arrow-right class="ml-2"></lucide-arrow-right>
          </v-btn>
        </router-link>
        <div style="font-size: 0.875rem; margin-top: 1rem;">
          No se requiere tarjeta de crédito. Comienza con el plan gratuito.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Importar componentes existentes
import HomePricingSection from '@/components/pricing/PricingSection.vue'
import TestimonialsSection from '@/components/testimonials/TestimonialsSection.vue'
import LastExampleCarousel from './components/LastExampleCarousel.vue'
import SolutionsSection from './components/SolutionsSection.vue'
import FAQs from './components/FAQs.vue'

// Importar iconos específicos de Lucide (opcional, ya que también se importan globalmente)
import {
  BookOpen,
  Brain,
  Frown,
  Check,
  HelpCircle,
  ArrowRight,
  FileText,
  Bot,
  Star,
  Bookmark,
  ShieldCheck
} from 'lucide-vue'

export default {
  name: 'HomePage',
  metaInfo() {
    return {
      title: 'SeleAI - Tu Tutor de IA para Estudios',
      titleTemplate: '%s',
      meta: [
        { name: 'description', content: 'Transforma tus apuntes en un tutor de IA interactivo. Crea cuestionarios, resúmenes y flashcards para mejorar tu aprendizaje.' },
        { name: 'keywords', content: 'tutor ia, estudio inteligente, cuestionarios ia, resúmenes ia, flashcards ia, aprendizaje personalizado' },

        // Open Graph
        { property: 'og:title', content: 'SeleAI - Tu Tutor de IA para Estudios' },
        { property: 'og:description', content: 'Transforma tus apuntes en un tutor de IA interactivo. Aprende más rápido y de forma más eficiente.' },
        { property: 'og:image', content: 'https://SeleAI/og-image.jpg' },
        { property: 'og:url', content: 'https://SeleAI/' },
        { property: 'og:type', content: 'website' },

        // Twitter
        { property: 'twitter:title', content: 'SeleAI - Tu Tutor de IA para Estudios' },
        { property: 'twitter:description', content: 'Transforma tus apuntes en un tutor de IA interactivo. Aprende más rápido y de forma más eficiente.' },
        { property: 'twitter:image', content: 'https://SeleAI/og-image.jpg' },
        { property: 'twitter:card', content: 'summary_large_image' }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'SeleAI',
            'applicationCategory': 'EducationalApplication',
            'operatingSystem': 'Web',
            'offers': {
              '@type': 'Offer',
              'price': '0',
              'priceCurrency': 'EUR'
            },
            'description': 'Transforma tus apuntes en un tutor de IA interactivo. Crea cuestionarios, resúmenes y flashcards para mejorar tu aprendizaje.',
            'aggregateRating': {
              '@type': 'AggregateRating',
              'ratingValue': '4.8',
              'ratingCount': '500'
            }
          }
        }
      ],

    };
  },
  components: {
    SolutionsSection,
    HomePricingSection,
    TestimonialsSection,
    LastExampleCarousel,
    FAQs,
    // Registrar componentes de Lucide (opcional)
    LucideBookOpen: BookOpen,
    LucideBrain: Brain,
    LucideFrown: Frown,
    LucideCheckCircle: Check,
    LucideHelpCircle: HelpCircle,
    LucideArrowRight: ArrowRight,
    LucideFileText: FileText,
    LucideBot: Bot,
    LucideStar: Star,
    LucideBookmark: Bookmark,
    LucideShieldCheck: ShieldCheck
  },
  data: () => ({
    demoAnswer1: null,
    typingWords: ['eficiente', 'inteligente', 'planificada', 'rápida', 'excelente'],
    currentTypingIndex: 0,
    typingText: '',
    isDeleting: false,
    typingSpeed: 150,
    carousel: 0,
    imagesCarousel: [
      {
        src: 'https://sele.ai:5556/api/images/other/1_sube_apuntes.webp',
        alt: 'SeleAI - Sube tus apuntes'
      },
      {
        src: 'https://sele.ai:5556/api/images/other/2_explicaciones.webp',
        alt: 'SeleAI - Explicaciones detalladas'
      },
      {
        src: 'https://sele.ai:5556/api/images/other/3_test.webp',
        alt: 'SeleAI - Tests interactivos'
      },
      {
        src: 'https://sele.ai:5556/api/images/other/4_flashcards.webp',
        alt: 'SeleAI - Flashcards de estudio'
      },
      {
        src: 'https://sele.ai:5556/api/images/other/5_chat.webp',
        alt: 'SeleAI - Chat con tu tutor IA'
      },
      {
        src: 'https://sele.ai:5556/api/images/other/6_comunidad.webp',
        alt: 'SeleAI - Apuntes de la comunidad'
      }
    ],
    communityContent: [
      {
        title: 'Cuestionario sobre Sistema Nervioso',
        time: 'hace 17m',
        author: 'MaríaGarcía',
        avatar: '/images/users/user1.jpg',
        description: '¿Cuál es la parte anterior del tubo neural?'
      },
      {
        title: 'Resumen: El significado ecológico y la diversidad de las plantas',
        time: 'hace 23m',
        author: 'CarlosRodríguez',
        avatar: '/images/users/user2.jpg',
        description: 'Resumen generado por SeleAI sobre la importancia de las plantas en ecosistemas'
      },
      {
        title: 'Cuestionario de Historia: La Guerra Civil Española',
        time: 'hace 38m',
        author: 'LauraFernández',
        avatar: '/images/users/user3.jpg',
        description: '¿Cuáles fueron las causas principales de la Guerra Civil Española?'
      }
    ],
    quizFeatures: [
      "Preguntas de opción múltiple, verdadero/falso y respuesta corta",
      "Control sobre la dificultad y número de preguntas",
      "Retroalimentación instantánea con explicaciones",
      "Compartir cuestionarios con compañeros"
    ],
    summaryFeatures: [
      "Extracción de conceptos clave y definiciones",
      "Organización jerárquica de la información",
      "Diagramas conceptuales para visualizar relaciones",
      "Múltiples formatos para diferentes estilos de aprendizaje"
    ],
    tutorFeatures: [
      "Respuestas personalizadas basadas en tus apuntes",
      "Explicaciones en profundidad de conceptos complejos",
      "Capacidad para hacer preguntas de seguimiento",
      "Disponible 24/7 para resolver tus dudas"
    ],
    activeTab: 0,
    exampleTabs: ["Cuestionarios Populares", "Resúmenes Destacados"],
    popularContent: [
      // Cuestionarios
      {
        id: 'q1',
        type: 'quiz',
        title: 'Fundamentos de Economía',
        subject: 'Economía',
        description: 'Cuestionario sobre conceptos básicos de microeconomía, incluyendo oferta, demanda y elasticidad.',
        author: 'María G.',
        authorAvatar: '../../assets/avatars/avatar1.jpg',
        rating: 4.8,
        questions: 25,
        time: 'hace 17m'
      },
      {
        id: 'q2',
        type: 'quiz',
        title: 'Anatomía del Sistema Nervioso',
        subject: 'Medicina',
        description: 'Preguntas sobre la estructura y función del sistema nervioso central y periférico.',
        author: 'Carlos R.',
        authorAvatar: '../../assets/avatars/avatar2.jpg',
        rating: 4.9,
        questions: 30,
        time: 'hace 23m'
      },
      {
        id: 'q3',
        type: 'quiz',
        title: 'Historia de España - Guerra Civil',
        subject: 'Historia',
        description: 'Repaso completo de las causas, desarrollo y consecuencias de la Guerra Civil Española.',
        author: 'Ana M.',
        authorAvatar: '../../assets/avatars/avatar3.jpg',
        rating: 4.7,
        questions: 40,
        time: 'hace 38m'
      },
      // Resúmenes
      {
        id: 's1',
        type: 'summary',
        title: 'Cálculo Diferencial',
        subject: 'Matemáticas',
        description: 'Resumen de los conceptos clave de cálculo diferencial, con ejemplos resueltos y fórmulas importantes.',
        author: 'Pablo S.',
        authorAvatar: '../../assets/avatars/avatar4.jpg',
        rating: 4.8,
        length: 15,
        time: 'hace 2d'
      },
      {
        id: 's2',
        type: 'summary',
        title: 'Literatura del Siglo de Oro',
        subject: 'Literatura',
        description: 'Síntesis de los principales autores y obras de la literatura española del Siglo de Oro.',
        author: 'Laura B.',
        authorAvatar: '../../assets/avatars/avatar5.jpg',
        rating: 4.6,
        length: 20,
        time: 'hace 2d'
      },
      {
        id: 's3',
        type: 'summary',
        title: 'Estructura Atómica y Tabla Periódica',
        subject: 'Química',
        description: 'Resumen sobre modelos atómicos, configuración electrónica y organización de la tabla periódica.',
        author: 'Javier M.',
        authorAvatar: '../../assets/avatars/avatar6.jpg',
        rating: 4.9,
        length: 18,
        time: 'hace 2d'
      }
    ],
    stats: [
      { value: "500K+", label: "Estudiantes activos" },
      { value: "2.5M+", label: "Cuestionarios generados" },
      { value: "1.8M+", label: "Resúmenes creados" },
      { value: "92%", label: "Satisfacción" }
    ],
    testimonials: [
      {
        quote: "Sele.ai ha revolucionado completamente mi forma de estudiar. Los cuestionarios que genera son increíblemente útiles para repasar antes de los exámenes y el tutor IA me ha ayudado a entender conceptos complejos que no lograba captar en clase.",
        name: "Laura Martínez",
        title: "Estudiante de Medicina, Universidad de Barcelona",
        avatar: "../../assets/testimonials/testimonial1.jpg"
      },
      {
        quote: "Como profesor, recomiendo SeleAI a todos mis alumnos. La plataforma les ayuda a procesar mejor la información de clase y les permite practicar de forma interactiva. He notado una mejora significativa en las calificaciones de quienes la utilizan regularmente.",
        name: "Dr. Miguel Sánchez",
        title: "Profesor de Química, Universidad Complutense de Madrid",
        avatar: "../../assets/testimonials/testimonial2.jpg"
      },
      {
        quote: "Aprobar oposiciones requiere procesar enormes cantidades de información. Gracias a SeleAI he podido generar resúmenes concisos de temarios extensos y crear cuestionarios para evaluar mi conocimiento. ¡Fundamental para mi preparación!",
        name: "Carlos Rodríguez",
        title: "Opositor, Administración Pública",
        avatar: "../../assets/testimonials/testimonial3.jpg"
      }
    ],
    pricingFaqs: [
      {
        question: '¿Puedo cambiar de plan en cualquier momento?',
        answer: 'Sí, puedes actualizar o cambiar tu plan en cualquier momento. Si actualizas, se te cobrará la diferencia prorrateada. Si bajas de categoría, el nuevo plan comenzará al final de tu ciclo de facturación actual.'
      },
      {
        question: '¿Qué métodos de pago aceptan?',
        answer: 'Aceptamos todas las principales tarjetas de crédito y débito (Visa, Mastercard, American Express), PayPal y transferencia bancaria para planes de equipo.'
      },
      {
        question: '¿Hay descuentos para estudiantes o instituciones educativas?',
        answer: 'Sí, ofrecemos un 20% de descuento adicional para estudiantes verificados e instituciones educativas. Contacta con nuestro equipo de ventas para más información.'
      },
      {
        question: '¿Qué incluye la prueba gratuita de 14 días?',
        answer: 'La prueba gratuita te da acceso completo a todas las funciones del plan elegido durante 14 días. No se te cobrará nada hasta que finalice el período de prueba, y puedes cancelar en cualquier momento.'
      },
      {
        question: '¿Cómo funciona la garantía de devolución?',
        answer: 'Si no estás satisfecho por cualquier motivo, puedes solicitar un reembolso completo dentro de los 30 días posteriores a tu compra inicial. No hacemos preguntas y procesamos los reembolsos en un plazo de 5-7 días hábiles.'
      }
    ],
    uploadedFiles: [],
    carouselInterval: null,
    currentSlide: 0
  }),
  methods: {
    typeEffect() {
      const currentWord = this.typingWords[this.currentTypingIndex];
      const typingElement = document.getElementById('typing-effect');

      if (!typingElement) return;

      if (this.isDeleting) {
        // Borrando texto
        this.typingText = currentWord.substring(0, this.typingText.length - 1);
      } else {
        // Escribiendo texto
        this.typingText = currentWord.substring(0, this.typingText.length + 1);
      }

      typingElement.textContent = this.typingText;

      let typeSpeed = this.typingSpeed;

      if (this.isDeleting) {
        typeSpeed /= 2; // Borrar más rápido
      }

      if (!this.isDeleting && this.typingText === currentWord) {
        // Pausa al final de la palabra
        typeSpeed = 2000;
        this.isDeleting = true;
      } else if (this.isDeleting && this.typingText === '') {
        this.isDeleting = false;
        // Pasar a la siguiente palabra
        this.currentTypingIndex = (this.currentTypingIndex + 1) % this.typingWords.length;
        // Pausa antes de comenzar a escribir
        typeSpeed = 500;
      }

      setTimeout(() => this.typeEffect(), typeSpeed);
    },
    getStarted() {
      this.$router.push('/crear-cuestionario');
    },
    goToFeature(route) {
      this.$router.push('/' + route);
    },
    openExample(id) {
      // Implementar apertura de ejemplo
      console.log('Abriendo ejemplo:', id);
    },
    exploreMore(category) {
      this.$router.push('/' + category);
    },
    handleFilesUpdated(files) {
      // Actualizar los archivos subidos
      this.uploadedFiles = files;
    },
    handleProcessFiles(files) {
      console.log('Procesando archivos desde el componente principal:', files);
      // Implementar lógica adicional para manejar archivos desde el componente principal
    },
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        if (this.$refs.slideGroup) {
          // Obtener el número total de elementos
          const totalSlides = this.popularContent.length;

          // Incrementar la diapositiva actual y volver a 0 si es necesario
          this.currentSlide = (this.currentSlide + 1) % totalSlides;

          // Desplazar programáticamente a la siguiente diapositiva
          this.$refs.slideGroup.onNext();
        }
      }, 3000); // Desplazar cada 3 segundos
    },
    stopCarousel() {
      clearInterval(this.carouselInterval);
    },
    setupDocumentosAnimation() {
      const documentoGrande = document.getElementById('documento-grande');
      const seleAI = document.getElementById('sele-ai');
      const documentos = document.querySelectorAll('.documento-animado');

      if (!documentoGrande || !seleAI || !documentos.length) return;

      const documentoRect = documentoGrande.getBoundingClientRect();
      const seleAIRect = seleAI.getBoundingClientRect();

      const startX = documentoRect.right;
      const endX = seleAIRect.left;
      const totalDistance = endX - startX;

      // Crear un nuevo estilo para la animación dinámica
      const styleSheet = document.createElement('style');
      styleSheet.id = 'documentos-animation-style';

      // Remover estilos anteriores si existen
      const oldStyle = document.getElementById('documentos-animation-style');
      if (oldStyle) oldStyle.remove();

      styleSheet.innerHTML = `
          @keyframes documentoMovimientoDinamico {
            0% {
              opacity: 0;
              transform: translateX(${-40}px) scale(0.4);
            }
            10% {
              opacity: 1;
              transform: translateX(${0}px) scale(0.6);
            }
            100% {
              opacity: 1;
              transform: translateX(${totalDistance + 60}px) scale(0.9);
            }
          }
        `;
      document.head.appendChild(styleSheet);

      styleSheet.style.marginLeft = '-100px';

      // Aplicar la nueva animación a todos los documentos
      documentos.forEach(doc => {
        doc.style.animationName = 'documentoMovimientoDinamico';
      });

    },
    setupSparkAnimation() {
      const documentoGrande = document.getElementById('sele-ai');
      const seleAI = document.getElementById('quiz');

      const documentos = document.querySelectorAll('.spark');

      if (!documentoGrande || !seleAI || !documentos.length) return;

      const documentoRect = documentoGrande.getBoundingClientRect();
      const seleAIRect = seleAI.getBoundingClientRect();

      const startX = documentoRect.right;
      const endX = this.$vuetify.breakpoint.xs ? seleAIRect.right - 30 : seleAIRect.left;
      const totalDistance = endX - startX;

      // Crear un nuevo estilo para la animación dinámica
      const styleSheet = document.createElement('style');
      styleSheet.id = 'spark-animation-style';

      // Remover estilos anteriores si existen
      const oldStyle = document.getElementById('spark-animation-style');
      if (oldStyle) oldStyle.remove();

      styleSheet.innerHTML = `
          @keyframes sparkMovimientoDinamico {
            0% {
              opacity: 1;
              transform: translateX(${-totalDistance / 3}px) scale(1.8);
            }
            90% {
              opacity: 1;
              transform: translateX(${totalDistance * 0.9}px) scale(1.3);
            }
            100% {
              opacity: 0;
              transform: translateX(${totalDistance}px) scale(1.2);
            }
          }
        `;
      document.head.appendChild(styleSheet);


      // Aplicar la nueva animación a todos los documentos
      documentos.forEach((doc, idx) => {
        doc.style.animationName = 'sparkMovimientoDinamico';
        doc.style.display = 'block';
        setTimeout(() => {
          doc.style.opacity = '1';
        }, idx * 300 + 3000);
      });
    }
  },
  mounted() {
    this.startCarousel();
    // Iniciar el efecto de escritura
    setTimeout(() => this.typeEffect(), 1000);

    // Recalcular la animación cuando la ventana cambie de tamaño
    // window.addEventListener('resize', this.setupDocumentosAnimation);
  },
  beforeDestroy() {
    // Detener el carrusel cuando el componente se destruya
    this.stopCarousel();
    // window.removeEventListener('resize', this.setupDocumentosAnimation);
  }
}
</script>

<style scoped>
.carousel-container-home>>>.v-window {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
}

/* Estilo general del sitio */
.hero-section {
  position: relative;
  min-height: 100vh;
  background-color: white;
  background-attachment: scroll;
  background-position: 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 700;
  color: #333;
  /* background-color: #e6f7e8; */
  background: linear-gradient(to bottom, #e6f7e8, white) !important;
  /* background-image: radial-gradient(#b9e9b4 1px, #e6f7e8 0.5px); */
  background-size: 20px 20px;
  background-repeat: repeat;
}

/* Ajuste de tamaño y estilo de fuentes */
h1,
h2,
h3,
h4,
.text-h1,
.text-h2,
.text-h3,
.text-h4 {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 900 !important;
  color: #4b4b4b !important;
  letter-spacing: -0.03em !important;
  text-wrap: balance;
}

.subtitle-1,
p,
span,
div {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  color: #4b4b4b;
}

/* Ajustes para botones más parecidos a Duolingo */
.get-started-btn,
.v-btn.primary,
.v-btn.primary-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 1.05rem !important;
  border-radius: 16px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  border: 2px solid #4dd453 !important;
  height: 48px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background-color: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white;
}

.get-started-btn:hover,
.v-btn.primary:hover,
.v-btn.primary-btn:hover {
  filter: brightness(1.02);
  box-shadow: 0 4px 0 #58a700 !important;
  transform: translateY(0) !important;
}

.get-started-btn:active,
.v-btn.primary:active,
.v-btn.primary-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: translateY(4px) !important;
}

/* Ajuste para botones outlined más similares a Duolingo */
.v-btn.outlined {
  border: 2px solid #e5e5e5 !important;
  background-color: white !important;
  color: #58a700 !important;
  font-weight: 800 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 0 #e5e5e5 !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease !important;
}

.v-btn.outlined:hover {
  border-color: #58a700 !important;
  box-shadow: 0 4px 0 rgba(28, 176, 246, 0.3) !important;
}

.v-btn.outlined:active {
  box-shadow: 0 0 0 #e5e5e5 !important;
  transform: translateY(4px) !important;
}

.pricing-card {
  max-width: 400px;
  margin: auto;
}

/* Ajustes de estilos para tarjetas */
.problem-card,
.example-card,
.community-card,
.pricing-card {
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
}

.problem-card:hover,
.community-card:hover,
.pricing-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 35px rgba(0, 0, 0, 0.12) !important;
}

/* Ajustes de colores y fondos */
.solution-section,
.stats-section {
  background: white;
  padding-top: 60px;
}

.examples-section {
  background-color: white;
  padding-top: 60px;
  padding-bottom: 30px;
}

.pricing-section {
  background-color: #f4ffee;
  background-image: radial-gradient(circle at center,
      transparent 0%,
      transparent 10%,
      #f4ffee 90%),
    radial-gradient(#6bcc60 1px, transparent 1px),
    radial-gradient(#6bcc60 1px, #f4ffee 1px) !important;
  background-size: 100% 100%, 20px 20px, 20px 20px;
  background-position: center, 0 0, 20px 20px;
  background-repeat: no-repeat, repeat, repeat;
  padding-top: 60px;
}

.community-section {
  background-color: white;
  padding-top: 60px;
  padding-bottom: 60px;
}

.testimonials-section {
  background-color: #f4ffee;
  padding-top: 60px;
  padding-bottom: 60px;
}


/* Badges de Duolingo */
.solution-badge,
.examples-badge,
.feature-badge,
.pricing-badge {
  background: #fff;
  color: #4dd453;
  border-radius: 16px;
  padding: 4px 8px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-content: center;
  justify-content: center;
  width: fit-content;
  border: 1px solid #e9e9e9
}



/* Mejoras en iconos */
.v-icon.success {
  color: #4dd453 !important;
  font-size: 24px !important;
}


/* Estilo para la sección de planes */
.popular-plan {
  transform: scale(1.05);
  border: 2px solid #4dd453 !important;
  box-shadow: 0 12px 24px rgba(88, 204, 2, 0.2) !important;
}

.popular-plan:hover {
  transform: scale(1.05) translateY(-5px);
}

.popular-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  width: fit-content;
  background: #f0fbee;
  color: #4CAF50;
  padding: 2px 6px;
  border-radius: 12px !important;
  font-size: 12px;
  font-weight: 500;
}

/* Tarjetas de precios */
.pricing-card h2 {
  color: #58a700 !important;
  font-size: 1.3rem !important
}

.feature-content {
  text-align: center;
}

/* Ajustes para toggles de precio */
.billing-toggle {
  background-color: #fff;
  border-radius: 100px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #f0f0f0;
}

.discount-chip {
  background-color: #4CAF50 !important;
  color: white !important;
  font-weight: 700 !important;
  border-radius: 50px !important;
  padding: 4px 16px !important;
}

/* Ajustes para la sección de garantía */
.money-back-guarantee {
  background-color: #fff;
  color: #4dd453;
  border-radius: 100px;
  font-weight: 800;
  padding: 12px 24px;
  border: 2px solid #e5f8d3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}


/* Ajustes de texto en general */
.tutor-ai-text {
  font-weight: 700;
  color: #4dd453 !important;
  position: relative;
  z-index: 1;
}

.tutor-ai-text::before {
  content: "";
  position: absolute;
  background-color: rgb(57 255 103 / 19%);
  width: 103%;
  height: 0.7em;
  bottom: 0em;
  left: 0;
  z-index: -1;
  transform: rotate(-4deg);
  transform-origin: left bottom;
}

/* Estilo para las tabs */
.example-tabs {
  border-radius: 100px;
  overflow: hidden;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  /* border: 2px solid #f0f0f0; */
}

.example-tabs>>>.v-tabs-slider-wrapper {
  display: none;
}

.example-tabs>>>.v-tab {
  text-transform: none !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
  min-width: 120px;
  border-radius: 12px !important;
  max-height: 40px
}

.v-tab--active {
  color: white !important;

  border: 2px solid #4dd453 !important;
  background: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
}



.user-avatar-google {
  margin-left: -16px !important;
}

.user-avatar-google {
  font-size: 14px
}


/* Estilos responsivos */
@media (max-width: 959px) {

  h1,
  .text-h1 {
    font-size: 2.25rem !important;
  }

  h2,
  .text-h2 {
    font-size: 2rem !important;
  }

  .get-started-btn,
  .v-btn.primary,
  .v-btn.primary-btn {
    font-size: 1.125rem !important;
  }

  .popular-plan {
    transform: scale(1);
  }

  .popular-plan:hover {
    transform: translateY(-5px);
  }
}

/* Estilos adicionales para elementos de estilo Duolingo */

/* Estilo para la mascota */
.mascot-image {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
  transition: transform 0.3s ease;
  animation: float 3s ease-in-out infinite;
}

.mascot-image:hover {
  transform: scale(1.1);
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0px);
  }
}

/* Estilo para la barra de progreso característica de Duolingo */
.progress-bar-duolingo {
  height: 16px;
  background-color: #e5e5e5;
  border-radius: 100px;
  overflow: hidden;
  margin: 24px 0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.progress-bar-duolingo .progress {
  height: 100%;
  background: linear-gradient(90deg, #4dd453, #76d639);
  border-radius: 100px;
  transition: width 0.5s ease;
}

/* Estilo para imágenes características con bordes redondeados */
.duolingo-image {
  border-radius: 24px;
  border: 3px solid white;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

/* Estilo para los iconos de estudio con el aspecto de Duolingo */
.study-icon {
  width: 64px;
  height: 64px;
  background-color: #e5f8d3;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 4px 0 #d1e6bf;
  transition: transform 0.2s ease;
}

.study-icon:hover {
  transform: translateY(-2px);
}

.study-icon i {
  font-size: 32px;
  color: #4dd453;
}



/* Estilos para el carrusel automático */
.carousel-container {
  max-width: 100% !important;
  overflow: hidden;
  position: relative;
}



/* Estilo para los divisores de sección al estilo Duolingo */
.section-divider {
  height: 24px;
  /* background-image: url('../../assets/wave-divider.svg'); */
  background-repeat: repeat-x;
  background-size: 24px 24px;
  width: 100%;
  margin: 0;
  padding: 0;
}

/* Estilo para las medallas y badges de logros */
.achievement-badge {
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border: 3px solid #ffc800;
  position: relative;
  overflow: hidden;
}

.achievement-badge::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 50%);
  border-radius: 50%;
}

.achievement-badge i {
  font-size: 40px;
  color: #ffc800;
}

/* Estilo para los elementos de "streak" diario */
.streak-counter {
  background-color: #ff9600;
  color: white;
  font-weight: 800;
  padding: 8px 16px;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 4px 0 #e57e00;
}

.streak-counter i {
  margin-right: 8px;
}

/* Estilos para el switch de Duolingo */
.v-input--switch .v-input--selection-controls__input {
  transform: scale(1.2);
}

.v-input--switch.primary--text .v-input--selection-controls__ripple,
.v-input--switch.primary--text .v-input--switch__thumb {
  color: #4dd453 !important;
}

.v-input--switch .v-input--selection-controls__ripple {
  transform: scale(1.2) !important;
}

.problem-section {
  background: white;

}

.transparent-bg {
  background: transparent !important;
}


.badge-wrapper {
  display: flex;
  align-content: center;
  justify-content: center;
}

.problem-avatar {
  border-radius: 12px !important;
}


.problem-avatar {
  background-color: #F8FAFC !important;
  border: 1px solid #E2E8F0 !important;
}

.problem-avatar>>>svg {
  border-radius: 0px !important;
  stroke: #0F172A !important;
}

/* Mejoras adicionales para avatares en la sección de testimonios */
.v-avatar.testimonial-avatar {
  border: 3px solid white !important;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 8px !important;
}

/* Estilo para pequeños indicadores de streak o progreso sobre avatares */
.v-avatar .avatar-indicator {
  position: absolute;
  bottom: -4px;
  right: -4px;
  background: #4dd453;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Estilos para iconos Lucide */
.lucide {
  stroke-width: 1.5;
  width: 24px;
  height: 24px;
}

/* Tamaños específicos */
.lucide.lucide-small {
  width: 16px;
  height: 16px;
}

.lucide.lucide-medium {
  width: 20px;
  height: 20px;
}

.lucide.lucide-large {
  width: 32px;
  height: 32px;
}

/* Animaciones para iconos en hover */
.problem-avatar .lucide {
  transition: transform 0.3s ease;
}


/* Ajuste para iconos en los avatares */
.v-avatar .lucide {
  width: 24px;
  height: 24px;
}

.lucide-check-circle {
  min-width: 24px;
}

.lucide-check {
  min-width: 24px;
}

/* Nuevos estilos para tarjetas verdes */
.quiz-card,
.summary-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: none !important;
}

.quiz-card:hover,
.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(46, 125, 50, 0.2) !important;
}

.green-background {
  background-color: #4CAF50 !important;
  padding-top: 16px;
  padding-bottom: 16px;
}

.green-light-background {
  background-color: #E8F5E9 !important;
}

/* Personalización para los botones verdes */
.v-btn.v-btn--outlined.theme--light {
  border: 2px solid #4CAF50 !important;
  color: #2E7D32 !important;
}

.v-btn.v-btn--outlined.theme--light:hover {
  background-color: rgba(76, 175, 80, 0.1) !important;
}

/* Estilo para las estrellas y botones */
.lucide-star,
.lucide-bookmark {
  color: #4CAF50 !important;
}

.example-tabs>>>.v-tab {
  color: #4CAF50 !important;
}

.example-tabs>>>.v-tab--active {
  color: white !important;
}

.green-card {
  background-color: #6ABF69 !important;
  border-radius: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.green-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
}

.view-button {
  background-color: rgba(255, 255, 255, 0.9) !important;
  color: #2E7D32 !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  height: 40px !important;
}

.view-button:hover {
  background-color: #ffffff !important;
}


/* Estilos para los iconos en estas tarjetas */
.green-card .v-icon {
  color: white !important;
}

/* Estilos para las tarjetas */
.card-style {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08) !important;
}

.card-style:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12) !important;
}

.green-bg {
  background-color: #58B758 !important;
}

.card-header {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.card-content {
  background-color: white;
}

.view-button {
  border: 1px solid #E0E0E0 !important;
  border-radius: 8px !important;
  color: #4CAF50 !important;
  font-weight: 500 !important;
  text-transform: none !important;
  background-color: white !important;
  transition: background-color 0.2s ease, border-color 0.2s ease !important;
}

.view-button:hover {
  background-color: rgba(76, 175, 80, 0.05) !important;
  border-color: #4CAF50 !important;
}

.explore-more-btn {
  background-color: white !important;
  color: #4CAF50 !important;
  border: 1px solid #e4ffe5 !important;
  border-radius: 16px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
  padding: 0 20px !important;
  transition: background-color 0.2s ease;
}

.explore-more-btn:hover {
  background-color: rgba(76, 175, 80, 0.05) !important;
}

.numbers-section {
  background: linear-gradient(295deg, rgba(111, 255, 0, 0.513), rgba(255, 255, 255, 0.7) 70%);
}

/* Estilos para los tabs de facturación */
.billing-tabs {
  max-width: 500px;
  margin: 0 auto;
  border-radius: 100px;
  overflow: hidden;
}

.billing-tabs>>>.v-tabs-slider-wrapper {
  display: none;
}

.billing-tabs>>>.v-tab {
  text-transform: none !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
  min-width: 150px;
  border-radius: 12px !important;
  font-size: 1rem;
}

.billing-tabs>>>.v-tab--active {
  color: white !important;
  border: 2px solid #4dd453 !important;
  background: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  margin-bottom: 4px;
}

.billing-tabs>>>.discount-chip {
  background-color: #fff !important;
  color: #4CAF50 !important;
  font-weight: 700 !important;
  border-radius: 50px !important;
  font-size: 0.8rem;
  padding: 2px 8px !important;
}

.billing-tabs>>>.v-tab--active .discount-chip {
  background-color: rgba(255, 255, 255, 0.9) !important;
  color: #58a700 !important;
}

.upload-area {
  border: 2px dashed #4dd453;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.upload-area:hover {
  background-color: rgba(76, 175, 80, 0.1);
}

.upload-area input[type="file"] {
  display: none;
}

.supported-files {
  margin-top: 10px;
  color: #616161;
  font-size: 0.9rem;
}

.selected-files-area {
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.selected-files-list {
  list-style-type: none;
  padding-left: 0;
}

.selected-file-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.selected-file-item .v-list-item-avatar {
  margin-right: 16px;
}

.selected-file-item .v-list-item-title {
  flex-grow: 1;
}

.selected-file-item .v-list-item-subtitle {
  color: #757575;
  font-size: 0.9rem;
}

.selected-file-item .v-list-item-action {
  margin-left: auto;
}

.selected-file-item .v-btn {
  margin-left: 8px;
}


.trusted-by-section>>>span {
  font-size: 0.9rem;
  font-weight: 500 !important;
  color: #999999;
}

/* Añadir estilos para el efecto de escritura */
#typing-effect {
  border-right: 2px solid #4dd453;
  padding-right: 5px;
  display: inline-block;
  position: relative;
}

#typing-effect::after {
  content: "";
  position: absolute;
  background-color: #4dd453;
  width: 100%;
  height: 3px;
  bottom: 10px;
  left: 0;
  z-index: 1;
  transform: rotate(-1deg);
  opacity: 0.6;
}

.rating-stars {
  font-size: 2rem;
}
</style>

<style>
/* Tailwind utility classes */
.absolute {
  position: absolute;
}

.inset-x-0 {
  left: 0;
  right: 0;
}

.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.top-0 {
  top: 0;
}

.h-96 {
  height: 24rem;
}

.h-full {
  height: 100%;
}

.w-full {
  width: 100%;
}

.rotate-180 {
  transform: rotate(180deg);
}

.rating-stars button {
  padding: 0 !important;
}

.text-gray-500\/20 {
  color: rgba(107, 114, 128, 0.2);
}

.opacity-60 {
  opacity: 0.14 !important;
}

.mask-gradient {
  -webkit-mask-image: linear-gradient(to bottom, transparent, white);
  mask-image: linear-gradient(to bottom, transparent, white);
}

@keyframes documentoMovimiento {
  0% {
    opacity: 0;
    transform: translateX(-150px) scale(0.5);
  }

  20% {
    opacity: 1;
    transform: translateX(-100px) scale(0.7);
  }

  80% {
    opacity: 1;
    transform: translateX(150px) scale(0.9);
  }

  100% {
    opacity: 0;
    transform: translateX(250px) scale(0.5);
  }
}

.documento-animado {
  position: absolute;
  left: 0;
  animation-name: documentoMovimiento;
  animation-timing-function: ease-in-out;
  width: 100%;
}

.position-relative {
  position: relative;
}
</style>
